export const CLASS_NAME = 'base-input-label';

export const DEFAULT_COMPONENT = 'label';
